module.exports = __webpack_public_path__ + "img/defaultClass.c4c2591a.png";